/**
 * Women Spot – Main Product Section
 * Dawn 16.0.0 compatible
 */

(function () {
  'use strict';

  const SECTION_SELECTOR =
    '[data-women-spot-product]';

  function getSection(element) {
    return element
      ? element.closest(SECTION_SELECTOR)
      : null;
  }

  function parseJSON(
    section,
    selector,
    fallback
  ) {
    const element =
      section.querySelector(selector);

    if (!element) return fallback;

    try {
      return JSON.parse(element.textContent);
    } catch (error) {
      console.error(
        'Women Spot: Invalid product JSON.',
        error
      );

      return fallback;
    }
  }

  function formatMoney(cents) {
    if (
      window.Shopify &&
      typeof window.Shopify.formatMoney ===
        'function'
    ) {
      return window.Shopify.formatMoney(cents);
    }

    const currency =
      window.Shopify &&
      window.Shopify.currency &&
      window.Shopify.currency.active
        ? window.Shopify.currency.active
        : 'INR';

    try {
      return new Intl.NumberFormat(
        document.documentElement.lang ||
          'en-IN',
        {
          style: 'currency',
          currency: currency,
          maximumFractionDigits:
            cents % 100 === 0 ? 0 : 2
        }
      ).format(cents / 100);
    } catch (error) {
      return `₹${(cents / 100).toFixed(
        cents % 100 === 0 ? 0 : 2
      )}`;
    }
  }

  function selectedOptions(section) {
    return Array.from(
      section.querySelectorAll(
        '.women-spot-option-group'
      )
    ).map(function (group) {
      const selected =
        group.querySelector(
          '.women-spot-option-btn.selected'
        );

      return selected
        ? selected.dataset.value
        : null;
    });
  }

  function findVariant(section) {
    const variants =
      section.womenSpotVariants || [];

    const options = selectedOptions(section);

    if (!options.length) {
      return variants[0] || null;
    }

    if (
      options.some(function (value) {
        return value === null;
      })
    ) {
      return null;
    }

    return (
      variants.find(function (variant) {
        return variant.options.every(
          function (value, index) {
            return value === options[index];
          }
        );
      }) || null
    );
  }

  function getVariantImage(variant) {
    if (
      !variant ||
      !variant.featured_media
    ) {
      return null;
    }

    const media = variant.featured_media;
    const preview =
      media.preview_image || {};

    return {
      id: media.id,
      src: preview.src || media.src,
      alt: media.alt || ''
    };
  }

  /*
   * फक्त पहिली main image update करा.
   * दुसरी मोठी image fixed राहील.
   */
  function updateMainImage(section, image) {
    if (!image || !image.src) return;

    const mainImage =
      section.querySelector(
        '.women-spot-main-image'
      );

    if (
      mainImage &&
      mainImage.tagName === 'IMG'
    ) {
      mainImage.src = image.src;
      mainImage.removeAttribute('srcset');

      if (image.alt) {
        mainImage.alt = image.alt;
      }
    }

    section
      .querySelectorAll(
        '.women-spot-thumbnail'
      )
      .forEach(function (thumbnail) {
        const active =
          String(
            thumbnail.dataset.mediaId
          ) === String(image.id);

        thumbnail.classList.toggle(
          'active',
          active
        );

        thumbnail.setAttribute(
          'aria-pressed',
          String(active)
        );

        if (active) {
          thumbnail.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest'
          });
        }
      });
  }

  function updatePrice(section, variant) {
    const current =
      section.querySelector(
        '[data-women-spot-current-price]'
      );

    const compare =
      section.querySelector(
        '[data-women-spot-compare-price]'
      );

    const discount =
      section.querySelector(
        '[data-women-spot-discount]'
      );

    const saleBadge =
      section.querySelector(
        '[data-women-spot-sale-badge]'
      );

    const onSale = Boolean(
      variant &&
      variant.compare_at_price &&
      variant.compare_at_price >
        variant.price
    );

    const percentage = onSale
      ? Math.round(
          ((variant.compare_at_price -
            variant.price) *
            100) /
            variant.compare_at_price
        )
      : 0;

    if (current && variant) {
      current.textContent =
        formatMoney(variant.price);
    }

    if (compare) {
      compare.hidden = !onSale;

      compare.textContent = onSale
        ? formatMoney(
            variant.compare_at_price
          )
        : '';
    }

    if (discount) {
      discount.hidden = !onSale;

      discount.textContent = onSale
        ? `Save ${percentage}%`
        : '';
    }

    if (saleBadge) {
      saleBadge.hidden = !onSale;

      saleBadge.textContent = onSale
        ? `${percentage}% OFF`
        : '';
    }
  }

  function updateButtons(
    section,
    variant
  ) {
    const variantInput =
      section.querySelector(
        '[data-women-spot-variant-id]'
      );

    const addButton =
      section.querySelector(
        '[data-women-spot-add-cart]'
      );

    const buyButton =
      section.querySelector(
        '[data-women-spot-buy-now]'
      );

    const available = Boolean(
      variant && variant.available
    );

    if (variantInput) {
      variantInput.value = variant
        ? variant.id
        : '';
    }

    if (addButton) {
      addButton.disabled = !available;

      const label =
        addButton.querySelector('span');

      if (label) {
        label.textContent = available
          ? 'Add to cart'
          : 'Sold out';
      }
    }

    if (buyButton) {
      buyButton.disabled = !available;

      buyButton.textContent = available
        ? 'Buy it now'
        : 'Sold out';
    }
  }

  function updateUrgency(
    section,
    variant
  ) {
    const urgency =
      section.querySelector(
        '[data-women-spot-urgency]'
      );

    if (!urgency || !variant) return;

    const inventory =
      section.womenSpotInventory || {};

    const quantity = Number(
      inventory[variant.id] || 0
    );

    if (!variant.available) {
      urgency.textContent =
        'Currently unavailable';
    } else if (
      quantity > 0 &&
      quantity <= 5
    ) {
      urgency.textContent =
        `Only ${quantity} left — order soon!`;
    } else {
      urgency.textContent =
        'Selling fast!';
    }
  }

  function updateURL(section, variant) {
    if (
      !variant ||
      !window.history.replaceState
    ) {
      return;
    }

    const url = new URL(
      window.location.href
    );

    url.searchParams.set(
      'variant',
      variant.id
    );

    window.history.replaceState(
      {},
      '',
      url.toString()
    );
  }

  function refreshOptionAvailability(
    section
  ) {
    const variants =
      section.womenSpotVariants || [];

    section
      .querySelectorAll(
        '.women-spot-option-btn'
      )
      .forEach(function (button) {
        const position =
          Number(
            button.dataset.optionPosition
          ) - 1;

        const available =
          variants.some(
            function (variant) {
              return (
                variant.available &&
                variant.options[position] ===
                  button.dataset.value
              );
            }
          );

        button.classList.toggle(
          'sold-out',
          !available
        );

        /*
         * Button clickable राहील.
         * Sold-out visual classने दाखवला जाईल.
         */
        button.disabled = false;

        button.dataset.available =
          String(available);
      });
  }

  function showMessage(
    section,
    message
  ) {
    const box = section
      ? section.querySelector(
          '.women-spot-cart-error-message'
        )
      : null;

    if (!box) return;

    box.textContent = message;
    box.hidden = false;
  }

  function hideMessage(section) {
    const box = section
      ? section.querySelector(
          '.women-spot-cart-error-message'
        )
      : null;

    if (!box) return;

    box.textContent = '';
    box.hidden = true;
  }

  function updateVariant(
    section,
    variant
  ) {
    hideMessage(section);

    if (!variant) {
      updateButtons(section, null);

      showMessage(
        section,
        'This option combination is unavailable.'
      );

      return;
    }

    updatePrice(section, variant);
    updateButtons(section, variant);
    updateUrgency(section, variant);

    updateMainImage(
      section,
      getVariantImage(variant)
    );

    updateURL(section, variant);
    refreshOptionAvailability(section);

    section.dispatchEvent(
      new CustomEvent(
        'womenSpot:variantChange',
        {
          bubbles: true,
          detail: {
            variant: variant
          }
        }
      )
    );
  }

  function setLoading(
    button,
    loading,
    loadingText
  ) {
    if (!button) return;

    if (loading) {
      button.dataset.originalHtml =
        button.innerHTML;

      button.disabled = true;
      button.classList.add('is-loading');
      button.textContent = loadingText;
    } else {
      if (
        button.dataset.originalHtml
      ) {
        button.innerHTML =
          button.dataset.originalHtml;
      }

      button.classList.remove(
        'is-loading'
      );

      button.disabled = false;
    }
  }

  /*
   * Add product and open Dawn cart drawer.
   */
  async function addToCart(button) {
    const section = getSection(button);
    const form = button.closest('form');

    if (!section || !form) return;

    hideMessage(section);

    const variantInput =
      form.querySelector('[name="id"]');

    const quantityInput =
      form.querySelector(
        '[name="quantity"]'
      );

    const variantId = variantInput
      ? variantInput.value
      : '';

    const quantity = Math.max(
      1,
      Number(
        quantityInput
          ? quantityInput.value
          : 1
      )
    );

    if (!variantId) {
      showMessage(
        section,
        'Please select an available size.'
      );

      return;
    }

    const originalHTML =
      button.innerHTML;

    setLoading(
      button,
      true,
      'Adding…'
    );

    try {
      const cartDrawer =
        document.querySelector(
          'cart-drawer'
        );

      const cartNotification =
        document.querySelector(
          'cart-notification'
        );

      const cartComponent =
        cartDrawer || cartNotification;

      const formData = new FormData();

      formData.append(
        'id',
        variantId
      );

      formData.append(
        'quantity',
        String(quantity)
      );

      if (
        cartComponent &&
        typeof cartComponent
          .getSectionsToRender ===
          'function'
      ) {
        const sections =
          cartComponent
            .getSectionsToRender()
            .map(function (item) {
              return item.id;
            });

        formData.append(
          'sections',
          sections.join(',')
        );
      } else {
        formData.append(
          'sections',
          'cart-drawer,cart-icon-bubble'
        );
      }

      formData.append(
        'sections_url',
        window.location.pathname
      );

      const addURL =
        window.routes &&
        window.routes.cart_add_url
          ? window.routes.cart_add_url
          : '/cart/add.js';

      const response = await fetch(
        addURL,
        {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With':
              'XMLHttpRequest'
          },
          body: formData
        }
      );

      const result =
        await response.json();

      if (
        !response.ok ||
        result.status
      ) {
        throw new Error(
          result.description ||
            result.message ||
            'Product could not be added.'
        );
      }

      button.innerHTML = originalHTML;

      button.classList.remove(
        'is-loading'
      );

      button.disabled = false;

      if (
        cartComponent &&
        typeof cartComponent
          .renderContents ===
          'function' &&
        result.sections
      ) {
        cartComponent.renderContents(
          result
        );

        window.setTimeout(
          function () {
            if (
              typeof cartComponent.open ===
              'function'
            ) {
              cartComponent.open(button);
            } else {
              cartComponent.classList.add(
                'active',
                'is-active'
              );
            }
          },
          100
        );
      } else if (cartDrawer) {
        cartDrawer.classList.add(
          'active',
          'is-active'
        );
      } else {
        const headerCartIcon =
          document.getElementById(
            'women-spot-cart-icon'
          );

        if (headerCartIcon) {
          headerCartIcon.click();
        } else {
          window.location.href =
            window.routes &&
            window.routes.cart_url
              ? window.routes.cart_url
              : '/cart';
        }
      }
    } catch (error) {
      button.innerHTML = originalHTML;

      button.classList.remove(
        'is-loading'
      );

      button.disabled = false;

      showMessage(
        section,
        error.message ||
          'Something went wrong. Please try again.'
      );
    }
  }

  function buyNow(button) {
    const section = getSection(button);
    const form = button.closest('form');

    if (!section || !form) return;

    hideMessage(section);

    const variantInput =
      form.querySelector('[name="id"]');

    const quantityInput =
      form.querySelector(
        '[name="quantity"]'
      );

    const variantId = variantInput
      ? variantInput.value
      : '';

    const quantity = Math.max(
      1,
      Number(
        quantityInput
          ? quantityInput.value
          : 1
      )
    );

    if (!variantId) {
      showMessage(
        section,
        'Please select an available option.'
      );

      return;
    }

    setLoading(
      button,
      true,
      'Opening checkout…'
    );

    window.location.href =
      `/cart/${encodeURIComponent(
        variantId
      )}:${quantity}`;
  }

  /*
   * Desktop आणि mobile zoom.
   */
  function initializeGalleryZoom(
    section
  ) {
    section
      .querySelectorAll(
        '.women-spot-gallery-image-wrapper'
      )
      .forEach(function (imageWrapper) {
        const galleryImage =
          imageWrapper.querySelector(
            '.women-spot-main-image, .women-spot-secondary-image'
          );

        if (!galleryImage) return;

        let pointerStartX = 0;
        let pointerStartY = 0;

        imageWrapper.addEventListener(
          'pointerdown',
          function (event) {
            pointerStartX =
              event.clientX;

            pointerStartY =
              event.clientY;
          },
          { passive: true }
        );

        /*
         * Desktop cursor-position zoom.
         */
        imageWrapper.addEventListener(
          'mousemove',
          function (event) {
            if (
              window.matchMedia(
                '(max-width: 989px)'
              ).matches
            ) {
              return;
            }

            const bounds =
              imageWrapper
                .getBoundingClientRect();

            const positionX =
              ((event.clientX -
                bounds.left) /
                bounds.width) *
              100;

            const positionY =
              ((event.clientY -
                bounds.top) /
                bounds.height) *
              100;

            galleryImage.style
              .transformOrigin =
              positionX +
              '% ' +
              positionY +
              '%';

            imageWrapper.classList.add(
              'is-hover-zooming'
            );
          }
        );

        imageWrapper.addEventListener(
          'mouseleave',
          function () {
            imageWrapper.classList.remove(
              'is-hover-zooming'
            );

            galleryImage.style
              .transformOrigin =
              'center center';
          }
        );

        /*
         * Mobile tap zoom.
         */
        imageWrapper.addEventListener(
          'click',
          function (event) {
            if (
              !window.matchMedia(
                '(max-width: 989px)'
              ).matches
            ) {
              return;
            }

            const movedX = Math.abs(
              event.clientX -
                pointerStartX
            );

            const movedY = Math.abs(
              event.clientY -
                pointerStartY
            );

            /*
             * Swipe झाला असेल तर
             * zoom activate करू नका.
             */
            if (
              movedX > 8 ||
              movedY > 8
            ) {
              return;
            }

            const bounds =
              imageWrapper
                .getBoundingClientRect();

            const positionX =
              ((event.clientX -
                bounds.left) /
                bounds.width) *
              100;

            const positionY =
              ((event.clientY -
                bounds.top) /
                bounds.height) *
              100;

            galleryImage.style
              .transformOrigin =
              positionX +
              '% ' +
              positionY +
              '%';

            const shouldZoom =
              !imageWrapper.classList
                .contains(
                  'is-mobile-zoomed'
                );

            /*
             * दुसऱ्या imageचा
             * zoom आधी बंद करा.
             */
            section
              .querySelectorAll(
                '.women-spot-gallery-image-wrapper.is-mobile-zoomed'
              )
              .forEach(
                function (wrapper) {
                  wrapper.classList.remove(
                    'is-mobile-zoomed'
                  );
                }
              );

            imageWrapper.classList.toggle(
              'is-mobile-zoomed',
              shouldZoom
            );
          }
        );
      });
  }

  function initializeSection(section) {
    if (
      section.dataset
        .womenSpotInitialized ===
      'true'
    ) {
      return;
    }

    section.dataset
      .womenSpotInitialized =
      'true';

    section.womenSpotVariants =
      parseJSON(
        section,
        '[data-women-spot-variant-data]',
        []
      );

    section.womenSpotInventory =
      parseJSON(
        section,
        '[data-women-spot-inventory-data]',
        {}
      );

    initializeGalleryZoom(section);

    const quantity =
      section.querySelector(
        '[data-women-spot-quantity]'
      );

    if (quantity) {
      quantity.addEventListener(
        'change',
        function () {
          quantity.value = Math.max(
            1,
            Number(quantity.value) || 1
          );
        }
      );
    }

    refreshOptionAvailability(
      section
    );
  }

  function initializeAll(root) {
    const container = root || document;

    if (
      container.matches &&
      container.matches(
        SECTION_SELECTOR
      )
    ) {
      initializeSection(container);
    }

    container
      .querySelectorAll(SECTION_SELECTOR)
      .forEach(function (section) {
        initializeSection(section);
      });
  }

  /*
   * Thumbnail click:
   * फक्त पहिली मोठी image बदलेल.
   */
  window.womenSpotChangeImage =
    function (thumbnail) {
      const section =
        getSection(thumbnail);

      if (!section) return;

      updateMainImage(section, {
        id: thumbnail.dataset.mediaId,
        src: thumbnail.dataset.src,
        alt:
          thumbnail.dataset.alt || ''
      });
    };

  window.womenSpotSelectVariant =
    function (button) {
      const section =
        getSection(button);

      const group = button.closest(
        '.women-spot-option-group'
      );

      if (!section || !group) return;

      hideMessage(section);

      group
        .querySelectorAll(
          '.women-spot-option-btn'
        )
        .forEach(function (item) {
          item.classList.remove(
            'selected'
          );

          item.setAttribute(
            'aria-pressed',
            'false'
          );
        });

      button.classList.add(
        'selected'
      );

      button.setAttribute(
        'aria-pressed',
        'true'
      );

      const selectedLabel =
        group.querySelector(
          '[data-selected-option-value]'
        );

      if (selectedLabel) {
        selectedLabel.textContent =
          button.dataset.value;
      }

      const variant =
        findVariant(section);

      if (!variant) {
        updateButtons(section, null);

        showMessage(
          section,
          'This size combination is unavailable.'
        );

        return;
      }

      updateVariant(
        section,
        variant
      );
    };

  window.womenSpotUpdateQty =
    function (change, control) {
      const form =
        control.closest('form');

      const input = form
        ? form.querySelector(
            '[data-women-spot-quantity]'
          )
        : null;

      if (!input) return;

      const minimum =
        Number(input.min) || 1;

      input.value = Math.max(
        minimum,
        (Number(input.value) || 1) +
          Number(change)
      );

      input.dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );
    };

  window.womenSpotProductAddToCart =
    addToCart;

  window.womenSpotProductBuyNow =
    buyNow;

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initializeAll(document);
      }
    );
  } else {
    initializeAll(document);
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initializeAll(event.target);
    }
  );
})();